<template>
  <div :class="{disabled: disabled, 'otp-input-wrapper': true}">
    <OtpInput
      v-for="(_,i) in numInputs"
      :disabled="disabled"
      class="otp-input"
      :key="'otp-input-'+i"
      :focus="activeInput === i"
      :value="otp[i]"
      @change="handleOnChange"
      @keydown="handleOnKeyDown"
      @paste="handleOnPaste"
      @focus="handleOnFocus(i)"
      @blur="handleOnBlur"
    />
  </div>
</template>

<script>
import OtpInput from './OptInput.vue';

const BACKSPACE = 8;
const LEFT_ARROW = 37;
const RIGHT_ARROW = 39;
const DELETE = 46;
export default {
  name: 'OtpInputWrapper',
  components: {
    OtpInput,
  },
  props: {
    numInputs: {
      type: Number,
      default: 5,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      activeInput: 0,
      otp: [],
      oldOtp: [],
    };
  },
  methods: {
    handleOnFocus (index) {
      this.activeInput = index;
    },
    handleOnBlur () {
      this.activeInput = -1;
    },
    checkFilledAllInputs () {
      if (this.otp.join('').length === this.numInputs) {
        return this.$emit('complete', this.otp.join(''));
      }
    },
    focusInput (input) {
      this.activeInput = Math.max(Math.min(this.numInputs - 1, input), 0);
    },
    focusNextInput () {
      this.focusInput(this.activeInput + 1);
    },
    focusPrevInput () {
      this.focusInput(this.activeInput - 1);
    },
    changeCodeAtFocus (value) {
      this.oldOtp = Object.assign([], this.otp);
      this.$set(this.otp, this.activeInput, value);
      if (this.oldOtp.join('') !== this.otp.join('')) {
        this.checkFilledAllInputs();
      }
    },
    handleOnPaste (event) {
      event.preventDefault();
      const pastedData = event.clipboardData
        .getData('text/plain')
        .slice(0, this.numInputs - this.activeInput)
        .split('');
      if (!pastedData.join('').match(/^\d+$/)) {
        return;
      }
      const currentCharsInOtp = this.otp.slice(0, this.activeInput);
      const combinedWithPastedData = currentCharsInOtp.concat(pastedData);
      this.$set(this, 'otp', combinedWithPastedData.slice(0, this.numInputs));
      this.focusInput(combinedWithPastedData.slice(0, this.numInputs).length);
      return this.checkFilledAllInputs();
    },
    handleOnChange (value) {
      this.changeCodeAtFocus(value);
      this.focusNextInput();
    },
    handleOnKeyDown (event) {
      switch (event.keyCode) {
        case BACKSPACE:
          event.preventDefault();
          this.changeCodeAtFocus('');
          this.focusPrevInput();
          break;
        case DELETE:
          event.preventDefault();
          this.changeCodeAtFocus('');
          break;
        case LEFT_ARROW:
          event.preventDefault();
          this.focusPrevInput();
          break;
        case RIGHT_ARROW:
          event.preventDefault();
          this.focusNextInput();
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .otp-input-wrapper{
    display: flex;
    &.disabled{
      cursor: not-allowed;
      opacity: 0.5;
    }
    .otp-input{
      &:not(:first-child){
        margin-left: 15px;
      }
    }
  }
</style>
